import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import FilterButton from '../shared/FilterButton';

export default function CustomWarranteeToolbar({
  updateOnclick,
  filterOnClick,
  modalState,
}) {
  return (
    <>
      <Typography
        className='WarranteeToolBar'
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        Warrantee Period (Years) By Product Line
      </Typography>
      <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
        <Button
          size='small'
          onClick={() => updateOnclick()}
          startIcon={<RefreshIcon />}
        >
          Refresh Data
        </Button>
        <FilterButton filterOnClick={filterOnClick} modalState={modalState} />
        <GridToolbarQuickFilter
          debounceMs={1000}
          sx={{
            right: { sm: 0 },
            position: { sm: 'absolute' },
            marginRight: { sm: '10px' },
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
